/**
 * Optimizer Store
 *
 * Zustand store for parlay optimizer modal state.
 * Manages legs, config, results, and modal open/close.
 */

import type { OptimizedParlaySet } from '@parlay-picker/shared/api/mlApi';
import { create } from 'zustand';
import type { OptimizerLeg } from '../views/picks/components/OptimizerModal';

interface OptimizerState {
  isOpen: boolean;
  legs: OptimizerLeg[];
  result: OptimizedParlaySet | null;
  loading: boolean;
  error: string | null;
  narratives: string[];
  enrichingNarrative: boolean;

  // Actions
  openWithLegs: (legs: OptimizerLeg[]) => void;
  close: () => void;
  setResult: (result: OptimizedParlaySet | null) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  setNarratives: (narratives: string[]) => void;
  setEnrichingNarrative: (enriching: boolean) => void;
  reset: () => void;
}

export const useOptimizerStore = create<OptimizerState>((set) => ({
  isOpen: false,
  legs: [],
  result: null,
  loading: false,
  error: null,
  narratives: [],
  enrichingNarrative: false,

  openWithLegs: (legs) => set({ isOpen: true, legs, result: null, error: null, narratives: [] }),
  close: () => set({ isOpen: false }),
  setResult: (result) => set({ result, loading: false }),
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error, loading: false }),
  setNarratives: (narratives) => set({ narratives, enrichingNarrative: false }),
  setEnrichingNarrative: (enrichingNarrative) => set({ enrichingNarrative }),
  reset: () =>
    set({
      isOpen: false,
      legs: [],
      result: null,
      loading: false,
      error: null,
      narratives: [],
      enrichingNarrative: false,
    }),
}));
